import Img from "@casino/legacy/client/shared/images/Img";
import getCdnIcon from "@casino/legacy/shared/cdn/getCdnIcon";

const PlayImage = () => (
  <div className="grid h-12 w-12 items-center justify-center rounded-full bg-white/25 mix-blend-normal backdrop-blur-sm">
    <Img
      width={20}
      height={20}
      alt="play game"
      src={getCdnIcon("play-triangle")}
    />
  </div>
);

export default PlayImage;
